// extracted by mini-css-extract-plugin
export default {"form":"ReplyForm_form__O7c9W","reply":"ReplyForm_reply__Jwqtg","submit":"ReplyForm_submit__S7UnH","attachment":"ReplyForm_attachment__gkCdH"};